import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import RequiredDocForm from './RequiredDocForm';
import CustomSpinner from './CustomSpinner';
import SaveStepButton from './SaveStepButton';
import { WAButton } from '../components/Button.js';

require(`../assets/${process.env.PAGE}/css/components/documents.css`)

class Documents extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customTitle: false,
      members: [],
      documents: [],
      quantityDocuments: null,
    };
    this.updateDocumentStatus = this.updateDocumentStatus.bind(this);
  }

  componentDidMount(){

    const ROOT_URL = process.env.API_URL;
    const config = {
      headers:
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    axios.get(`${ROOT_URL}/subscribers/members`, config).then((response)=> {
      if(response.data.members) {
        this.setState({
          members: response.data.members
        });
      }
      return axios.get(`${ROOT_URL}/steps/params`, config)
    }).then((response) => {
      if(response.data.files) {
        const documents = response.data.files.filter(f => !f.children);
        const membersDocuments = response.data.files.filter(f => f.children);

        const members = this.state.members.map(member => {
          let m = {...member };

          if (membersDocuments.length > 0) {
            m.documents = membersDocuments;
          }

          return m;
        });

        this.setState({
          documents: documents,
          members: members,
          quantityDocuments: response.data.files.length,
          customTitle: response.data.title || null,
        })
      }
    });
  }

  updateDocumentStatus(documentType, member=null) {
    const { documents, members } = this.state;

    if (member) {
      const updatedMembers = members.map(m => {
        if (m.id === member) {
          const memberDocuments = m.documents.map( d => {
            if (d.document_type === documentType) {
              d.loaded = true;
            }
            return d;
          });
          m.documents = memberDocuments;
        }
        return m;
      });

      this.setState({ members: updatedMembers });
    }

    if (!member) {
      const updatedDocuments = documents.map(d => {
        if (d.document_type === documentType) {
          d.loaded = true;
        }
        return d;
      })
      this.setState({ documents: updatedDocuments });
    }
  }


  render() {
    const { handleSubmit, isLoading } = this.props;
    const { documents, members, quantityDocuments, customTitle } = this.state;
    const requiredDocuments = documents.length > 0;
    const allRequiredDocumentsSubmited = documents.length > 0 && !documents.filter(d => d.required).map(d => d.loaded || false).includes(false);
    const memberHasDocuments = members.length > 0 && members[0]['documents'] && members[0]['documents'].length > 0;
    const memberHasRequiredDocuments = members.length > 0 && members[0]['documents'] && members[0]['documents'].filter(m => m.required).length > 0;
    const allMembersRequiredDocumentsSubmited = memberHasRequiredDocuments && !members.map(m => {
      return memberHasRequiredDocuments && !m.documents.filter(d => d.required).map(d => d.loaded || false).includes(false);
    }).includes(false);

    const title = customTitle ? (<h3>{customTitle}</h3>) : (<FormattedHTMLMessage id="app.step_documents" description="Sms info"/>);

    return (
      <Section className="intro_form">
        <div className="row">
          <div className="pd-content-left col-md-5 col-lg-5 text-center">
            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
            {title}
            <div className="show-desktop">
                <WAButton phone={this.context.intl.formatMessage({
                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                      text={this.context.intl.formatMessage({
                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                      value={this.context.intl.formatMessage({
                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                      gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                <SaveStepButton/>
            </div>
          </div>
          <div className={`pd-content-right ${quantityDocuments && quantityDocuments < 3 && 'short-content'} col-sm-12 col-md-7 col-lg-7`}>
            <form  className="pvc-form" onSubmit={handleSubmit(this.props.updateDocumentStep)}>
            {isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  { documents.map(d => {
                    return (
                      <RequiredDocForm
                        key={d.document_type}
                        label={d.label}
                        required={d.required}
                        documentType={d.document_type}
                        maxSize={d.max_size || 10000000}
                        fileTypes={d.types}
                        onUpdateStatus={this.updateDocumentStatus}/>
                    );
                  }) }
                </div>
              </div>
              <div className="row">
                  { memberHasDocuments && members.map(m => {
                    return (
                      <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                        <div className='member-title'>
                          {`CUIL: ${m.CUIL}`}
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          { m.documents.map(d => {
                            return (
                              <RequiredDocForm
                                key={`${m.id}-${d.document_type}`}
                                label={d.label}
                                required={d.required}
                                documentType={d.document_type}
                                maxSize={d.max_size || 10000000}
                                fileTypes={d.types}
                                subscriberId={m.id}
                                onUpdateStatus={(documentType) => {
                                  this.updateDocumentStatus(documentType, m.id);
                                }}/>
                            );
                          }) }
                        </div>
                      </div>
                    );

                  }) }
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                  <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={(memberHasRequiredDocuments && !allMembersRequiredDocumentsSubmited) || (requiredDocuments && !allRequiredDocumentsSubmited)}>Seguir</button>
                </div>
              </div>
            </form>
            <div className="show-mobile">
              <WAButton phone={this.context.intl.formatMessage({
                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                    text={this.context.intl.formatMessage({
                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                    value={this.context.intl.formatMessage({
                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
              <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
              <SaveStepButton/>
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

Documents.contextTypes = {
  intl: React.PropTypes.object.isRequired
}

Documents = TopScrolleable(Documents);

Documents = reduxForm({
  form: 'Documents', // a unique name for this form
})(Documents);

Documents = withAuthControl(Documents);

export default Documents;


/** WEBPACK FOOTER **
 ** ./src/components/Documents.js
 **/